module.exports = __webpack_public_path__ + "img/bevill-logo.cb6b1a09.jpg";